import { render, staticRenderFns } from "./Plantillas.vue?vue&type=template&id=c71442ca&"
import script from "./Plantillas.vue?vue&type=script&lang=js&"
export * from "./Plantillas.vue?vue&type=script&lang=js&"
import style0 from "./Plantillas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports